import { ControllerAPI } from "../api/api";
import createListApiState from "./lib/ListApiState";

export const [
    rolesSlice,
    loadRoles,
    updateRolesManually
] = createListApiState({
    name: "Roles",
    execute: ControllerAPI.loadRoles
});
